var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { Component } from 'react';
import { setDisplayName } from './setDisplayName';
import { wrapDisplayName } from './wrapDisplayName';
export var withContext = function (childContextTypes, getChildContext) { return function (BaseComponent) {
    var WithContext = /** @class */ (function (_super) {
        __extends(WithContext, _super);
        function WithContext() {
            var _this = _super !== null && _super.apply(this, arguments) || this;
            _this.getChildContext = function () { return getChildContext(_this.props); };
            return _this;
        }
        WithContext.prototype.render = function () {
            return React.createElement(BaseComponent, __assign({}, this.props));
        };
        WithContext.childContextTypes = childContextTypes;
        return WithContext;
    }(Component));
    if (process.env.NODE_ENV !== 'production') {
        return setDisplayName(wrapDisplayName(BaseComponent, 'withContext'))(WithContext);
    }
    return WithContext;
}; };
